module.exports = __webpack_public_path__ + "img/clothing66.a02c5128.jpg";